import React from 'react';

import ListPageHeader from '@shared/ListPageHeader';
import { formatDateTime } from '@utils/dateTime';
import { Card, Table, Tag, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLoaderData, Link } from 'react-router-dom';

export default function InventoryOrders() {
  const data = useLoaderData();
  const { t } = useTranslation();

  const statusColors = {
    waiting: 'default',
    processing: 'processing',
    shipped: 'success',
    completed: 'success',
    canceled: 'error',
    closed: 'default',
  };

  const columns = [
    {
      title: t('models.order.name'),
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (text, record) => (
        <Link to={`/orders/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: t('models.order.receiver_name'),
      dataIndex: 'receiver_name',
      key: 'receiver_name',
      width: 150,
    },
    {
      title: t('models.order.sales_channel'),
      dataIndex: 'sales_channel_name',
      key: 'sales_channel_name',
      width: 120,
      render: (text) => text || '-',
    },
    {
      title: t('models.order.shipping_type'),
      dataIndex: 'shipping_type_name',
      key: 'shipping_type_name',
      width: 120,
      render: (text) => text || '-',
    },
    {
      title: t('models.order.status'),
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => (
        <Tag color={statusColors[status] || 'default'}>
          {t(`enums.order.status.${status}`)}
        </Tag>
      ),
    },
    {
      title: t('models.inventory.allocated_quantity'),
      dataIndex: 'allocated_quantity',
      key: 'allocated_quantity',
      width: 100,
      align: 'right',
      render: (value) => value || 0,
    },
    {
      title: t('common.created_at'),
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (date) => formatDateTime(date),
    },
  ];

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['stocks', 'stocks.current', { label: `${data.product_sku} - ${data.product_name}` }, { label: t('models.inventory.orders_title') }]}
      />
      <Card>
      {/* 庫存資訊 */}
      <Card type="inner" title={t('models.inventory.inventory_info')} style={{ marginBottom: '24px' }}>
        <Descriptions column={3}>
          <Descriptions.Item label={t('models.product.sku')}>
            {data.product_sku || '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('models.product.name')}>
            {data.product_name || '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('models.inventory.batch')}>
            {data.batch || '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('models.inventory.allocated_quantity')}>
            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#faad14' }}>
              {data.allocated_quantity || 0}
            </span>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      {/* 訂單列表 */}
      <Table
        columns={columns}
        dataSource={data.orders || []}
        rowKey="id"
        pagination={false}
      />
    </Card>
    </div>
  );
}
